var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{},[_vm._v(_vm._s(_vm.minContent))]),(_vm.isAllBtn)?_c('span',{staticClass:"show-more text-blue",on:{"click":_vm.showAll}},[_vm._v("全文")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }